import { type RouteObject } from 'react-router-dom';

import { ExcludedPage, Component } from './page';

export const ExcludedRoute = {
  Component: ExcludedPage,
} satisfies RouteObject;

export const ExcludedRouteNewPortal = {
  Component,
};
